// @module Tavanoteam.CustomerEventRegistration.CustomerEventConfirmation
define('Tavanoteam.CustomerEventRegistration.CustomerEventConfirmation.View'
,	[
		'tavanoteam_customereventregistration_customereventconfirmation.tpl'
		
	,	'Backbone'
    ]
, function (
		tavanoteam_customereventregistration_customereventconfirmation_tpl
	
	,	Backbone
)
{
    'use strict';

	// @class Tavanoteam.CustomerEventRegistration.CustomerEventConfirmation.View @extends Backbone.View
	return Backbone.View.extend({

		template: tavanoteam_customereventregistration_customereventconfirmation_tpl

	,	initialize: function (options) {

			//Get Configuration
			this.getEventConfirmationHeading = SC.CONFIGURATION.TTCustomerEventRegistration.eventConfirmationHeading;

			//Get Options
			this.getEventName = options.eventName;
			this.getEventVendorBtnName = options.eventVendorBtnName;
			this.getEventVendorBtnLink = options.eventVendorBtnLink;
		
		}

		//@method getContext @return Tavanoteam.CustomerEventRegistration.CustomerEventConfirmation.View.Context
	,	getContext: function getContext()
		{
			//@class Tavanoteam.CustomerEventRegistration.CustomerEventConfirmation.View.Context

			var defaultHeading = "Success.";

			//Show Vendor Button
			this.displayVendorBtn = false;
			if (this.getEventVendorBtnName && this.getEventVendorBtnLink) {
				this.displayVendorBtn = true;
			}

			return {
				eventConfirmationHeading: this.getEventConfirmationHeading ? this.getEventConfirmationHeading : defaultHeading,
				eventName: this.getEventName,
				displayVendorBtn: this.displayVendorBtn,
				eventVendorBtnName: this.getEventVendorBtnName,
				eventVendorBtnLink: this.getEventVendorBtnLink
			};
		}
	});
});
